import { Image } from '@app/shared/ui/atoms/Common';
import { EmojiGrid } from '@app/shared/ui/molecules/Cognition';
import { ABILITIES_EMOJIS } from '@app/shared/constants/cognition';
import { diamondWhiteIcon } from '@app/assets';

export const StonesBannerAbilities = () => (
  <div className="flex flex-1 flex-col justify-around gap-[14px]">
    <Image src={diamondWhiteIcon} className="ml-auto mr-4 h-[23px] w-[30px]" alt="diamond icon" />

    <EmojiGrid emojis={ABILITIES_EMOJIS} />
  </div>
);
